import React from 'react';

import { FilterContext } from '../../Context/FilterContext';
import FilteredProducts from '../Components/Products/FilteredProducts';
import UnfilteredProducts from '../Components/Products/UnfilteredProducts';
import { FilterResult as ProductInterface } from '../Types';

export default function ProductsContainer() {
    const { result, isLoading, isFilterActive } = React.useContext(FilterContext);

    if (isFilterActive === true) {
        const productIsRecommended = (product: ProductInterface): boolean =>
            product.customerSpecificData.passesSkinCheck;

        const recommendedProducts = result
            .filter((product) => productIsRecommended(product))
            .sort((a, b) =>
                a.customerSpecificData.passesIngredientsCheck === b.customerSpecificData.passesIngredientsCheck
                    ? 0
                    : a.customerSpecificData.passesIngredientsCheck
                      ? -1
                      : 1,
            );

        const notRecommendedProducts = result.filter((product) => !productIsRecommended(product));

        return (
            <FilteredProducts
                recommendedProducts={recommendedProducts}
                notRecommendedProducts={notRecommendedProducts}
                isLoading={isLoading}
            />
        );
    } else {
        // the result from the context appears to be used in other places, not super confident in making the sorting immutable
        // eslint-disable-next-line rulesdir/use-to-sorted-over-sort
        const sortedProducts = result.sort((a, b) =>
            a.customerSpecificData.passesIngredientsCheck === b.customerSpecificData.passesIngredientsCheck
                ? 0
                : a.customerSpecificData.passesIngredientsCheck
                  ? -1
                  : 1,
        );
        return <UnfilteredProducts products={sortedProducts} isLoading={isLoading} />;
    }
}
